import { couponPrice, findNotUseAbleCoupon, setGoodsCouponListRequest } from '@/composables/useOrderCoupon';

export const groupSaleSumPrice = ref<number>(0); //등급할인 금액 총합
export const goodsBasicSumPrice = ref<number>(0); //상품 기본 할인 총합
export const goodsOriSumPrice = ref<number>(0); //원래 상품의 총합
export const goodsTtobakSumPrice = ref<number>(0); //정기구독 할인 총합
export const orderList = ref<Record<string, any>[]>([]);    // 주문목록
export const totalQuantity = ref<number>(0); // 총 주문개수
export const totalSumSalePrice = ref<number>(0); // 총 할인금액
export const realPaymentPrice = computed(() => {// 실 결제금액
  let result = goodsOriSumPrice.value - totalSumSalePrice.value + deliveryPrice.value
 return result >= 0 ? result : 0
});
export const emoneyRaw = ref<number>(0); // 적립금
export const emoney = computed({
  get() {
    return emoneyRaw.value.toLocaleString(); // 숫자를 콤마 형식으로 변환하여 반환
  },
  set(value: string) {
    emoneyRaw.value = parseInt(value.replace(/[^0-9]/g, ''), 10) || 0; // 입력된 값을 숫자로 변환하여 저장
  }
});
export const emoneyForNormalRaw = ref<number>(0); // 일반상품 적립금
export const emoneyForNormal = computed({
  get() {
    return emoneyForNormalRaw.value.toLocaleString(); // 숫자를 콤마 형식으로 변환하여 반환
  },
  set(value: string) {
    emoneyForNormalRaw.value = parseInt(value.replace(/[^0-9]/g, ''), 10) || 0; // 입력된 값을 숫자로 변환하여 저장
  }
});
export const emoneyForSubscriptionRaw = ref<number>(0); // 정기구독 적립금
export const emoneyForSubscription = computed({
  get() {
    return emoneyForSubscriptionRaw.value.toLocaleString(); // 숫자를 콤마 형식으로 변환하여 반환
  },
  set(value: string) {
    emoneyForSubscriptionRaw.value = parseInt(value.replace(/[^0-9]/g, ''), 10) || 0; // 입력된 값을 숫자로 변환하여 저장
  }
});
export const isAllUseEmoneyInCart = ref<boolean>(false);
export const isAllUseNotEmoney = ref<boolean>(false); //전체 적립금불가상품인경우
export const emoneyError = ref<string>(''); //적립금메세지

export const deliveryPrice = ref<number>(3000); // 배송비
export const deliveryObject = ref<Record<string, any> >({}); // 배송비 정보

export const isWatch = ref<boolean>(false);
export const selectedPayments = ref<Record<string, any>[]>([]);
const getPaymentMode = () => {
  const route = useRoute();
  return ( route.query.mode as string ) ?? 'DIRECT'
};
export const isSubscribePage = () => {
  const route = useRoute();
  return route.path.includes('setRoutineShipping');
};

export const isSinglePage = () => {
  const route = useRoute();
  return route.path.includes('settle');
};

const isCombinePage = () => {
  const route = useRoute();
  return route.path.includes('setCombineShipping');
};

const getMode = () => {
  const route = useRoute();
  const mode = route.query.mode ?? ''
  return mode
};

/**
 * 주문결제 페이지 여부 체크
 * 이전페이지로 이동하면서 async로 함수는 실행되며 mode를 못읽어오는 경우 발생
 * 결제페이지가 아닌경우 중단처리위함
 * @returns 
 */
export const isNotCurrentPage = () => {
  const route = useRoute();
  if (isSubscribePage() || isSinglePage() || isCombinePage()) {
    return false
  }
  console.warn('페이지가 이동되었으므로 초기화 중단');
  return true;
}

//==========================================================================================
// 주문시 사용하는 공통로직함수 (쿠폰제외)
// 타입 : 단품 / 정기구독 / 단품+정기구독
// 공통부분제외하고 페이지별 필요한 내용은 로직내 isSubscribePage , isSinglePage, isCombinePage 로구분
//=========================================================================================

/**
 * 또박배송 결제일 기본값 설정
 * @returns 
 */
export const getPaymentDaysAPI = async () => {
  const rootStore = useRootStore();
  const { $sendGet } = useNuxtApp();
  let paymentDaysValue = null;
  let paymentDayValue: string = '';

  const result = await $sendGet({
    url: getStoreApiUrl('order', '', '/l2') + '/subscription/availablePaymentDays',
    showDefaultLoading: false
  })

  if (result.data?.RESULT_CODE !== '0') {
    rootStore.toast(getErrorMessage(result.data?.RESULT_CODE ?? ''));
  } else {
    paymentDaysValue = result.data?.DATA
    const today = new Date().getDate().toString().padStart(2, '0')
    const lastDay = paymentDaysValue[paymentDaysValue.length - 1]

    paymentDayValue = today > lastDay ? lastDay : today;
    paymentDaysValue = paymentDaysValue.map((day: number) =>
      day.toString().padStart(2, '0') // 숫자를 문자열로 변환하고 2자리로 만듦
    );
  }
  return { paymentDaysValue, paymentDayValue }
};


/**
 * 변수를 한군데서 관리하므로 기본적으로 데이터 초기화작업 필요
 * @param orderListValue 
 */
const initValue = (orderListValue: Record<string, any>[]) => {
  //초기화작업
  orderList.value.length == 0
  orderList.value = orderListValue
  deliveryPrice.value = 0
  deliveryObject.value = {}
  goodsOriSumPrice.value = 0
  totalSumSalePrice.value = 0 
  goodsBasicSumPrice.value = 0
  groupSaleSumPrice.value = 0
  goodsTtobakSumPrice.value = 0
  couponPrice.value = 0
  //  isAllUseEmoneyInCart.value = result.data?.SUBDATA?.isAllUseEmoneyInCart ?? false
  //TODO
  isAllUseEmoneyInCart.value = false
  selectedPayments.value.length == 0
  isAllUseNotEmoney.value = false
  initEmoney()
}

/**
 * 주문목록 조회
 * @returns 
 */
export const getOrderList = async () => {
  const { $sendGet } = useNuxtApp();
  const rootStore = useRootStore();
  const router = useRouter();

  if(isNotCurrentPage()){
    return 
  }

  const result = await $sendGet({
    url: `${getStoreApiUrl('order', '', '/l1')}/Item/${getPaymentMode()}`,
    showDefaultLoading: false
  })
  if (result.data?.RESULT_CODE === '0') {

    //처음 화면 진입시 초기화
    initValue(result.data?.DATA)

    if (orderList.value.length === 0) {
      rootStore.showMessageDialog('구매할 상품이 없습니다.', '확인', (() => { router.go(-1) }))
      return false
    }

    if (!checkStock(orderList.value)) {
      rootStore.showMessageDialog('상품의 재고 수량이 부족하여 구매가 불가합니다.', '확인', (() => { router.go(-1) }))
      return false
    }

    let findNotUseAbleEmoney = orderList.value.filter(item => item.useEmoneyYn === false);
    //사용할 수 없는 갯수와 주문 갯수가 똑같으면
    if (findNotUseAbleEmoney?.length == orderList.value?.length) {
      isAllUseNotEmoney.value = true;
    }

   //=================== 페이지 이동처리 =======================
    const hasSubscription = orderList.value.some(item => isTypeSubscription(item.goodsType));
    const hasNormal = orderList.value.some(item => isTypeNormal(item.goodsType));
    const isCombine = hasSubscription && hasNormal
    
    //단품구매 페이지인데 정기구독상품존재 or 정기구독페이지인데 단품상품 존재하는경우
    if( (isSinglePage() && hasSubscription )  || isSubscribePage() && hasNormal ){
      const mode = getMode()
      goOrderPay(`mode=${mode}`, hasSubscription, true, isCombine);
      return false
    }

    //===================정기구독 & 결합 주문서======================
    if (isSubscribePage() || isCombinePage()) {
      orderList.value.forEach(orderItem => {
        if (orderItem.goodsSubscriptionPolicy) {
          orderItem.isChangePaymentDay = false;
          orderItem.showGuide = false;
        }
      });
    }

  } else {
    rootStore.showMessageDialog('구매할 상품이 없습니다.', '확인', (() => { router.go(-1) }))
    return false
  }

  calPriceInit()
  return true
};

// 결제 및 할인금액 초기데이터 세팅
export const calPriceInit = () => {
  totalQuantity.value = orderList.value.reduce((sum, item) => sum + item.quantity, 0);
  goodsOriSumPrice.value = orderList.value.reduce((sum, item) => { return sum + item.totalRegularPrice }, 0) //상품의 정가

  //정기구독상품 > subscriptionSaleAmount 있으면 등급할인가와 비교하여 더 높은금액
  //단품상품 > subscriptionSaleAmount 없으면 totBasicSalePrice과 등급할인가 비교하여 더 높은금액
  let groupSaleSumPriceValue = 0;
  let goodsBasicSumPrcieValue = 0;
  let goodsTtobakSumPriceValue = 0;

  orderList.value.forEach(item => {
    if (item.subscriptionSalePrice) {
      // 정기구독 상품의 경우
      if (item.subscriptionSaleAmount >= item.groupSaleAmount) {
        goodsTtobakSumPriceValue += item.subscriptionSaleAmount * item.quantity;
      } else {
        groupSaleSumPriceValue += item.groupSaleAmount * item.quantity;
      }
    } else {
      // 단품 상품의 경우 (상품할인과 등급할인 비교)
      if (item.totalSaleAmount > (item.groupSaleAmount * item.quantity) ) {
        goodsBasicSumPrcieValue += item.totalSaleAmount;
      } else {
        groupSaleSumPriceValue += item.groupSaleAmount * item.quantity;
      }
    }
  });

  //등급, 상품, 또박할인 
  groupSaleSumPrice.value = groupSaleSumPriceValue;
  goodsBasicSumPrice.value = goodsBasicSumPrcieValue;
  goodsTtobakSumPrice.value = goodsTtobakSumPriceValue;

  // 총 할인 금액 (상품할인 + 또박 할인 + 등급 할인 + 쿠폰)
  totalSumSalePrice.value = goodsBasicSumPrice.value + groupSaleSumPrice.value + goodsTtobakSumPrice.value + couponPrice.value
  // realPaymentPrice.value = orderList.value.reduce((sum, item) => sum + item.totalSalePrice, 0);

};

// 가격 계산
export const calPrice = () => {
  const numEmoney = Number(emoney.value.replace(/[^0-9]/g, ''))
  totalSumSalePrice.value = goodsTtobakSumPrice.value + goodsBasicSumPrice.value + groupSaleSumPrice.value + couponPrice.value + numEmoney
};


/**
 * 최대 사용 적립금 계산
 * @param findNotUseAbleEmoney 
 * @param goodsOriSumPrice  원래 상품의 총합
 * @param groupSaleSumPrice  등급할인 금액 총합
 * @param findNotUseAbleCoupon 
 * @param goodsTtobakSumPrice 정기구독 할인 총합
 * @param couponPriceValue 쿠폰금액
 * @param realPaymentPrice 실 결제금액
 * @param goodsBasicSumPrcie 상품 기본 할인 금액 (또박만있는경우는 불필요 기본 0)
 * @returns 
 */
export const calculateMaxEmoney = (findNotUseAbleEmoney: Record<string, any>[]): number => {

  let maxEmoney = 0 //최고적립금

  if (findNotUseAbleEmoney?.length >= 1) {
    let minusGroupOriPrice = 0;
    let minusGroupSalePrice = 0;
    let minusBasicSalePrice = 0;
    let minusTtobakSalePrice = 0;

    findNotUseAbleEmoney.forEach(item => {
      // 각 항목의 총 가격을 더함
      // minusGroupOriPrice += item.totConsumerPrice;

      if (item.subscriptionSaleAmount != 0 ) {
        // 정기구독 상품의 경우
        if (item.groupSalePrice == null || item.subscriptionSaleAmount >= item.groupSaleAmount) {
          minusTtobakSalePrice += (item.regularPrice - item.subscriptionSaleAmount);
        } else {
          minusGroupSalePrice += item.groupSalePrice;
        }
      } else {
        // 단품 상품의 경우
        if (item.totalGroupSalePrice == null || item.totalSalePrice > item.totalGroupSalePrice) {
          minusBasicSalePrice += item.totalSalePrice;
        } else {
          minusGroupSalePrice += item.totalGroupSalePrice;
        }
      }
    });

    let minusFindItem =  (minusGroupSalePrice + minusBasicSalePrice + minusTtobakSalePrice - findNotUseAbleCoupon.value);
    console.log('minusFindItem:::::::', minusFindItem);
    maxEmoney = Math.min(0.3 * ((goodsOriSumPrice.value - (goodsBasicSumPrice.value + groupSaleSumPrice.value + goodsTtobakSumPrice.value + couponPrice.value) - minusFindItem))); //수정 후 결제금액 30%

  } else {
    maxEmoney = Math.min(0.3 * (goodsOriSumPrice.value - (goodsBasicSumPrice.value + groupSaleSumPrice.value + goodsTtobakSumPrice.value + couponPrice.value)));
  }

  maxEmoney = cutOffPrice(maxEmoney)
  calculateEmoneyDetail(maxEmoney)
  console.log('maxEmoney::::::::::::::::::::::1111111', maxEmoney);

  return maxEmoney
}

/**
 * 적립금 배분 계산
 * @param useEmoney 사용할 적립금 (최대값, 사용자의 최대 적립금, 사용자가 입력한 값)
 */
const calculateEmoneyDetail = ( useEmoney : number) => {
  useEmoney = cutOffPrice(useEmoney)
  let useEmoneyList = orderList.value.filter(item => item.useEmoneyYn === true);
  let subscribeSalePrice = 0; //정기구독 상품의 적립금
  let normalSalePrice = 0; //단품 상품의 적립금

  useEmoneyList.forEach(item => {
    // 각 항목의 총 가격을 더함
    if (item.subscriptionSaleAmount != 0 ) {
      // 정기구독 상품의 경우
      if (item.groupSalePrice == null || item.subscriptionSaleAmount >= item.groupSaleAmount) {
        subscribeSalePrice  += item.subscriptionSalePrice;
      } else {
        subscribeSalePrice  += item.groupSalePrice;
      }
    } else {
      // 단품 상품의 경우
      if (item.totalGroupSalePrice == null || item.totalSalePrice > item.totalGroupSalePrice) {
        normalSalePrice += item.totalSalePrice;
      } else {
        normalSalePrice += item.totalGroupSalePrice;
      }
    }
  });

  const totalSalePrice = normalSalePrice + subscribeSalePrice

  //정기구독만 or 일반상품만 있는경우
  if (subscribeSalePrice === 0) {
    emoneyForNormalRaw.value = cutOffPrice(useEmoney);
    emoneyForSubscriptionRaw.value = 0;
  } else if (normalSalePrice === 0) {
    emoneyForNormalRaw.value = 0;
    emoneyForSubscriptionRaw.value = cutOffPrice(useEmoney)
  } else {
    const normalRatio = normalSalePrice / totalSalePrice;
    emoneyForNormalRaw.value =  Math.floor(useEmoney * normalRatio / 10) * 10 ;
    emoneyForSubscriptionRaw.value = useEmoney - emoneyForNormalRaw.value;
  }
}


// 적립금 focus 초기화
export const initEmoney = () => {
  emoneyRaw.value = 0
  emoneyForNormalRaw.value = 0
  emoneyForSubscriptionRaw.value = 0
};

/**
 * 적립금 전액사용하기
 * @param isChangeCupon 
 * @returns 
 */
export const useAllEmoney = (isChangeCupon: boolean) => {
  const memberInfo = useMemberStore()

  try {
    let findNotUseAbleEmoney = orderList.value.filter(item => item.useEmoneyYn === false);
    console.log('findNotUseAbleEmoney:::::', findNotUseAbleEmoney);

    //사용할 수 없는 갯수와 주문 갯수가 똑같으면
    if (findNotUseAbleEmoney?.length == orderList.value?.length) {
      isAllUseNotEmoney.value = true;
      return false;
    }

    if (realPaymentPrice.value < 0) {
      return false
    }

    if (!isChangeCupon && memberInfo.emoney < 10) {
      emoneyError.value = '10원 단위로 입력해 주세요'
      return false
    }

    //최대 적립금계산
    let maxEmoney = calculateMaxEmoney(findNotUseAbleEmoney)

    if (realPaymentPrice.value < 0 && realPaymentPrice.value < maxEmoney) {
      maxEmoney = realPaymentPrice.value
      emoney.value = comma(maxEmoney)
      return false;
    }

    if (memberInfo.emoney > 0) {
      emoneyRaw.value = Math.min(cutOffPrice(memberInfo.emoney), maxEmoney);
    }

    emoneyError.value = ''

  } finally {
    //버튼클릭시 재계산필요
    calculateEmoneyDetail(emoneyRaw.value)
    calPrice()
  }

};

/**
 * 적립금 변경
 * @param couponPriceValue 쿠폰가격
 * @returns 
 */
export const updateEmoney = () => {
  const memberInfo = useMemberStore()

  //입력값없는경우 0 세팅
  if(!emoney.value) {
    initEmoney()
  }
  const numEmoney = Number(emoney.value.replace(/[^0-9]/g, ''))

  try {
    if (numEmoney > 0) {

      let findNotUseAbleEmoney = orderList.value.filter(item => item.useEmoneyYn === false);
      console.log('findNotUseAbleEmoney222222::::::', findNotUseAbleEmoney);

      if (findNotUseAbleEmoney?.length == orderList.value?.length) {
        isAllUseNotEmoney.value = true;
        return false;
      }

      if (memberInfo.emoney < 10 || numEmoney > memberInfo.emoney) {
        emoneyError.value = '보유한 적립금이 부족해요'
        initEmoney()
        return false
      }

      if (numEmoney < 10 || !isInteger(numEmoney)) {
        emoneyError.value = '10원 단위로 입력해 주세요'
        initEmoney()
        return false
      }

      //10원입력시에는 적립금 세부내역 안보여주기
      if(numEmoney == 10){
        emoneyForNormalRaw.value = 0
        emoneyForSubscriptionRaw.value = 0
        return false
      }

      //최대적립금계산
      let maxEmoney = calculateMaxEmoney(findNotUseAbleEmoney )
      if (realPaymentPrice.value <= 0 && realPaymentPrice.value < maxEmoney) {
        maxEmoney = realPaymentPrice.value
        emoney.value = comma(maxEmoney)
        calculateEmoneyDetail(emoneyRaw.value)
        return false;
      }

      if (maxEmoney < numEmoney) {
        maxEmoney = cutOffPrice(maxEmoney)
        emoneyError.value = `최대 ${comma(maxEmoney)}원까지 사용가능해요.`
        emoneyRaw.value = maxEmoney
        calPrice()
        return false
      }
    }

    emoneyError.value = ''

  } finally {
    //버튼클릭시 재계산필요
    if(numEmoney != 10) {
      calculateEmoneyDetail(emoneyRaw.value)
    }
    calPrice()
  }
};



/**
 * 배송비조회
 * @param choiceItem 선택된 배송지 정보
 * @param isInit 초기진입여부
 */
export const getShippingCost = async (choiceItem: Record<string, any> | null = {}) => {
  const { $sendPost } = useNuxtApp();
  const rootStore = useRootStore();

  if(isNotCurrentPage()){
    return 
  }

  let paramsDelivery: Record<string, any> = {}
  if (choiceItem) {
    paramsDelivery = { ...choiceItem }
  }

  const data: Record<string, any> = {
    cartType: getPaymentMode(),
    goodsCouponRequestList: [],
    deliveryAddress : paramsDelivery.roadAddress
  }
  //초기화
  data.goodsCouponRequestList.length == 0
  data.goodsCouponRequestList = setGoodsCouponListRequest();
  data.shippingCouponIssuanceSeq = selectedShippingCoupon.value?.couponIssuanceSeq ?? null 

  const result = await $sendPost({
    url: `${getStoreApiUrl('order', '', '/l1')}/shippingFee`,
    data: data,
    showDefaultLoading: false
  })
  if (result.data?.RESULT_CODE === '0') {
    deliveryObject.value = result.data?.DATA
    deliveryPrice.value = deliveryObject.value?.shippingFeeInfo?.discountApplyPrice ?? 3000
    // if (isInit) {
    //   calPriceInit()
    // } else {
      calPrice()
    // }
  } else {
    rootStore.toast(getErrorMessage(result.data?.RESULT_CODE ?? ''));
  }
};

/**
 * 배송비 재계산 루틴
 * 1. 배송비조회
 * 2. 배송비쿠폰 세팅
 * 3. 배송비조회 (배송비쿠폰이 있을경우, 배송비쿠폰 포함하여 재계산)
 */
export const calculateFinalShippingCost = async (deliveryData :Record<string, any> | null = {}) => {
    // 배송비 쿠폰 초기화 후 배송비 부과여부확인
    selectedShippingCouponSeq.value = 0;
    selectedShippingCoupon.value = {};
    await getShippingCost(deliveryData)
    // 배송비가 부과되는 경우에만 배송비쿠폰 세팅
    if(deliveryPrice.value > 0) {
      
      //기본배송비 이외의 개별배송비 or 도서산간비가 부과되는경우에는 쿠폰세팅하지않음
      if( deliveryObject.value.shippingFeeInfo?.basicShippingFee == 0 && 
        ( deliveryObject.value.shippingFeeInfo?.individualShippingFee != 0 || deliveryObject.value.shippingFeeInfo?.landOrMountainousAreaFee !=0 )){
        return false
      }

      shippingCouponInitSet(); // 배송비쿠폰 세팅
      if(selectedShippingCouponSeq.value != 0) {
        await getShippingCost(deliveryData)
      }
    }
};
